export default String.prototype.nl2brIfNotHTML = function() {
    const text = this.toString();
    const tinyEditorIsUsed = text.search(/<[^\/].*>/g) >= 0 && text.search(/<\/.*>/g) >= 0;
    return tinyEditorIsUsed 
        ? text
        : text.replace(/\n/g,'<br>');
}